import { frontendURL } from '../../../helper/URLHelper';

const KanbanIndex = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KanbanIndex,
  },
];
